<template>
    <div class="project">
        <div :class="{'banner':true,'blankBanner':!bannerUrl}">
            <img style="cursor:pointer" @click="changeLink()" :src="bannerUrl" alt="">
        </div>
        <div class="body">
            <wrap 
            :cateName="cateName"
            :title="categoryList"
            :location="location"
            @change-page="selectProduct"
            @openChange="openChange"
            :selectedKeys="selectedKeys"
            :openKeys="openKeys"
            :modelName="'产品中心'">
                <slot>
                    <a-spin :spinning="spinning">
                    <div v-if="isDetail" class="detail">
                        <a-icon v-if="isReturn" style="font-size:24px;color:#2b83ff;cursor:pointer;float:right" @click="isDetail=false" type="left-square" />
                        <div class="detailTitle">{{productName}}</div>
                        <div v-html="content" class="ql-snow ql-editor"></div>
                    </div>
                    <template v-else>
                        <div class="productList" v-for="(value,index) in productList" :key="index">
                            <img :src="apiUrl+value.product_img" alt="">
                            <div class="content">
                                <p  :title="value.product_name" @click="toDetail(value)">{{value.product_name}}</p>
                                <div class="text">{{value.product_abstract}}</div>
                                <div class="titleBox">{{value.product_abstract}}</div>
                            </div>
                        </div>
                    </template>
                    </a-spin>
                </slot>
            </wrap>
        </div>
    </div>
</template>
<script>
import {getBannerListApi,getCategoryListApi,getProductListApi,getProductContentApi} from "@/request/api"
import {Icon,Spin} from "ant-design-vue"
import wrap from "@/components/wrap"
export default {
    name:"project",
    components:{
        wrap,
        aIcon:Icon,
        aSpin:Spin
    },
    data(){
        return{
            location:['产品中心','课程资源'],
            categoryList:[],
            productList:[],
            apiUrl:window.g.apiUrl,
            content:null,
            searchInfo:{
                is_more: 0,
                cur_index: 100,
                category_id:null
            },
            isDetail:false,
            productName:'',
            selectedKeys:[],
            spinning:false,
            isReturn:true,
            cateName:'',
            openKeys:[],
            bannerUrl:'',
            bannerLink:''
        }
    },
    mounted(){
        this.init()
        if(this.$route.query.id){
            this.toDetail({product_id:this.$route.query.id})
        }
        
    },
    methods:{
        init(){
            this.getToken(getCategoryListApi,this.searchInfo,res=>{
                this.categoryList=res.data.map(item=>({'title':item.category_name,'id':item.category_id,'menuList':item.sub_have_products==1?item.sub_list.map(value=>({'title':value.sub_name,'id':value.sub_id,'isProduct':false})):item.product_list.map(product=>({'title':product.product_name,'id':product.product_id,'isProduct':true}))}))
                let categoryId=this.categoryList[0].id
                let sub_id=this.categoryList[0].menuList[0].id
                let isProduct=this.categoryList[0].menuList[0].isProduct
                this.changePage(categoryId,sub_id,isProduct)
                this.cateName=this.categoryList[0].title
                this.openKeys=[parseInt(categoryId)]
                this.selectedKeys=[categoryId+'-'+sub_id]
            })
            this.getToken(getBannerListApi,{},res=>{
                let info=res.data.filter(item=>item.link==2)[0]
                this.bannerUrl=info.banner_img
                this.bannerLink=info.banner_name
            })
        },
        openChange(e){
            this.openKeys=[e[1]]
        },
        selectProduct(data){
            this.isDetail=false
            let categoryId=data[0].split('-')[0]
            this.openKeys=[parseInt(categoryId)]
            this.cateName=this.categoryList.filter(item=>item.id==categoryId)[0].title
            let subId=data[0].split('-')[1]
            let isProduct=this.categoryList.filter(item=>item.id==categoryId)[0].menuList.filter(item=>item.id==subId)[0].isProduct
            this.selectedKeys=[categoryId+'-'+subId]
            if(data.length==1){
                this.changePage(categoryId,isProduct)
            }else{
                this.changePage(categoryId,subId,isProduct)
            }   
        },
        changePage(category_id,sub_id,isProduct){
            this.content=''
            if(isProduct){
                this.toDetail({product_id:sub_id})
                this.isReturn=false
            }else{
                this.getToken(getProductListApi,{category_id:category_id,sub_id:sub_id},res=>{
                    this.isReturn=true
                    this.productList=res.data.map(item=>({...item,'product_img':item.product_img&&item.product_img.replace(/\/download/,'public')}))
                })
            }
        },
        toDetail(data){
            this.spinning=true
            this.getToken(getProductContentApi,{product_id:data.product_id},res=>{
                this.isDetail=true
                this.spinning=false
                this.content=res.data[0].resource_list[1].resource_content
                this.productName=res.data[0].product_name
                this.selectedKeys=[res.data[0].category_id+'-'+(res.data[0].sub_id||res.data[0].product_id)]
                this.cateName=res.data[0].category_name
                this.openKeys=[parseInt(res.data[0].category_id)]
            })
            
        },
        changeLink(){
            if(this.bannerLink){
                window.open(this.bannerLink, '_blank')
                return
            }
        }
       
    }
}
</script>
<style>
.ql-video{
    height:400px;
    width:80%;
    margin:0 auto;
}
</style>
<style lang="stylus" scoped>
.project
    background:#f3f3f2;
    .banner
        img 
            width:100%;
    .body
        min-height:600px;
        .productList
            display:flex;
            padding:30px;
            border-bottom:1px solid #e9e9e9;
            img     
                flex-shrink:0;
                height:240px;
                width:356px;
            .content
                position:relative;
                padding:30px;
                
                .titleBox
                    font-size:14px;
                    border:1px solid #454545;
                    background:#fff;
                    padding:3px;
                    position:absolute;
                    top:200px;
                    left:150px;
                    display:none;
                    z-index:3;
                p
                    font-size:22px;
                    font-weight:bold;
                    cursor:pointer;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    &:hover
                        color:#2b83ff
                .text
                    color:#7c7c7c;
                    font-size:16px;
                    text-align:justify;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 5;
                    overflow: hidden;
                    &:hover
                        ~.titleBox
                            display:block;
        .detail
            padding:30px;
            .detailTitle
                font-size:26px;
                text-align:center;
                margin:30px;
            
            

</style>